import React, { Component } from "react";
import Layout from "../../../Layout/layout";
import Helmet from "react-helmet";
import "../../../styles/reports/reports.scss";
import axios from "axios";
import { connect } from "react-redux";
import moment from "moment";
import { Button, Modal, Table } from "react-bootstrap";
import Calendar from "react-calendar/dist/umd/Calendar";
import GridLoader from "react-spinners/GridLoader";
import Select from "react-select";
import { apiHost } from "../../../api/apiClient";
import { setErrorMessage, setHeaderVisible, setLoadingPage } from "../../../reducers/actions";
import AssetInforWarning from "../../commoncomponents/assetInforWarning";
import GroupWarning from "../../commoncomponents/groupWarning";
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import { here_api_key } from "../../../utils/mapapi";

const RANGE_OPTIONS = [
  { label: "Today", days: 1 },
  { label: "1 Week", days: 7 },
];

const DEFAULT_MAP_CENTER = { lat: -25.2744, lng: 133.7751 };

class GeofenceEntryExit extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    this.state = {
      groupDetails: [],
      groupId: "",
      customerId: "",
      assetList: [],
      assetId: "",
      assetName: "",
      assetLoader: false,
      isLoading: false,
      geofences: [],
      geofenceId: "",
      minDuration: 0,
      selectedRangeDays: 1,
      calendarShow: false,
      calendarStartDate: today.toDate(),
      reportDate: today.format("YYYY-MM-DD"),
      dataPlaceholder: today.format("dddd Do MMMM, YYYY"),
      reportLoader: false,
      reportGenerated: false,
      errorLoader: false,
      errorMessage: "",
      reportDetails: null,
      selectedMapEvent: null,
      selectedGeofence: null,
      showMapModal: false,
      showPreviewModal: false,
      previewGeofence: null,
      geofenceMenuOpen: false,
      loadedReportParams: null,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.previewMenuHoldUntil = 0;
  }

  async componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    await this.loadGroups();
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    this.disposeMap();
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ calendarShow: false });
    }
  }

  getAuthHeaders = () => ({
    Authorization: "Bearer " + localStorage.getItem("token"),
  });

  getGeofenceId = (geofence) => {
    const value = geofence ? geofence.id || geofence.Id : "";
    return value == null ? "" : String(value);
  };

  getGeofenceName = (geofence) => geofence
    ? geofence.name || geofence.Name || "Unnamed POI Zone"
    : "Unnamed POI Zone";

  getGeofenceOwnerName = (geofence) => geofence
    ? geofence.createdByUserName || geofence.CreatedByUserName || geofence.createdByUserId || geofence.CreatedByUserId || ""
    : "";

  isGeofencePrivate = (geofence) => !!(geofence && (geofence.private || geofence.Private));

  loadGroups = async () => {
    try {
      const response = await axios.post(
        `${apiHost}/api/Notification/AllGroupForNotification`,
        {},
        { headers: this.getAuthHeaders() }
      );
      this.setState({ isLoading: false, groupDetails: response.data || [] });
    } catch (e) {
      this.setState({ isLoading: true });
      console.warn("Report request failed");
    }
  };

  loadGeofences = async () => {
    if (!this.state.customerId) {
      this.setState({ geofences: [], geofenceId: "" });
      return;
    }

    try {
      const response = await axios.get(`${apiHost}/api/POI/GetAllPOIs?customerId=${this.state.customerId}`, {
        headers: this.getAuthHeaders(),
      });
      const geofences = response.data || [];
      this.setState((prevState) => ({
        geofences,
        geofenceId: geofences.some((geofence) => this.getGeofenceId(geofence) === prevState.geofenceId)
          ? prevState.geofenceId
          : "",
      }));
    } catch (e) {
      this.setState({ geofences: [], geofenceId: "", errorMessage: "Unable to load POI Zones." });
      console.warn("Report request failed");
    }
  };

  getAssets = async () => {
    if (!this.state.groupId) {
      return;
    }

    try {
      this.setState({ assetLoader: true });
      const response = await axios.get(
        `${apiHost}/api/Notification/AssetsByGroupId/${this.state.groupId}?IsReport=true`,
        { headers: this.getAuthHeaders() }
      );
      this.setState({
        assetList: response.data.paggedlist || [],
        assetLoader: false,
      });
    } catch (e) {
      this.setState({ assetList: [], assetLoader: false });
      console.warn("Report request failed");
    }
  };

  handleGroupSelection = (selectedGroup) => {
    if (!selectedGroup) {
      this.setState({
        groupId: "",
        customerId: "",
        assetList: [],
        assetId: "",
        assetName: "",
        geofences: [],
        geofenceId: "",
      });
      return;
    }

    this.setState(
      {
        groupId: selectedGroup.data.groupId,
        customerId: selectedGroup.data.customerId,
        assetList: [],
        assetId: "",
        assetName: "",
        geofences: [],
        geofenceId: "",
      },
      this.getAssets
    );
  };

  handleAssetSelection = (selectedAsset) => {
    if (!selectedAsset) {
      this.setState({ assetId: "", assetName: "", geofences: [], geofenceId: "" });
      return;
    }

    this.setState(
      {
        assetId: selectedAsset.data.assetId,
        assetName: selectedAsset.data.name || selectedAsset.label,
        geofences: [],
        geofenceId: "",
      },
      this.loadGeofences
    );
  };

  handleGeofenceSelection = (selectedGeofence) => {
    this.setState({
      geofenceId: selectedGeofence ? selectedGeofence.value : "",
      geofenceMenuOpen: false,
    });
  };

  handleGeofenceMenuClose = () => {
    if (this.state.showPreviewModal || Date.now() < this.previewMenuHoldUntil) {
      this.setState({ geofenceMenuOpen: true });
      return;
    }

    this.setState({ geofenceMenuOpen: false });
  };

  handleRangeChange = (days) => {
    const selectedStart = days === 1 ? moment() : moment().subtract(days - 1, "days");
    this.setState({
      selectedRangeDays: days,
      calendarStartDate: selectedStart.toDate(),
      reportDate: selectedStart.format("YYYY-MM-DD"),
      dataPlaceholder: selectedStart.format("dddd Do MMMM, YYYY"),
    });
  };

  calendarFunction = () => {
    this.setState({ calendarShow: !this.state.calendarShow });
  };

  onChangeDate = (date) => {
    this.setState({
      calendarStartDate: date,
      reportDate: moment(date).format("YYYY-MM-DD"),
      dataPlaceholder: moment(date).format("dddd Do MMMM, YYYY"),
      calendarShow: false,
    });
  };

  getEndDate = () => moment(this.state.reportDate).add(this.state.selectedRangeDays - 1, "days").format("YYYY-MM-DD");

  canCreateReport = () => !!(this.state.groupId && this.state.assetId && this.state.geofenceId && this.state.reportDate);

  handleCreateReport = async () => {
    if (!this.canCreateReport()) {
      return;
    }

    this.setState({
      reportLoader: true,
      reportGenerated: true,
      errorLoader: false,
      errorMessage: "",
      reportDetails: null,
      loadedReportParams: {
        groupId: this.state.groupId,
        assetId: this.state.assetId,
        geofenceId: this.state.geofenceId,
        reportDate: this.state.reportDate,
        endDate: this.getEndDate(),
        selectedRangeDays: this.state.selectedRangeDays,
        minDuration: parseInt(this.state.minDuration, 10) || 0,
      },
    });

    try {
      const response = await axios.post(
        `${apiHost}/api/Report/GeofenceEntryExit`,
        {
          assetId: this.state.assetId,
          geofenceId: this.state.geofenceId,
          startDate: this.state.reportDate,
          endDate: this.getEndDate(),
          timezone: localStorage.getItem("timeZoneID") || "Australia/Melbourne",
          minDuration: parseInt(this.state.minDuration, 10) || 0,
        },
        { headers: this.getAuthHeaders() }
      );

      this.setState({
        reportLoader: false,
        reportDetails: response.data,
      });
    } catch (e) {
      const errorMessage = e.response && e.response.data
        ? e.response.data.error || e.response.data.message || e.response.data
        : "Something went wrong while generating this report.";
      this.setState({
        reportLoader: false,
        errorLoader: true,
        errorMessage,
      });
    }
  };

  handleWindow = () => {
    this.props.setHeaderVisibleAction(!this.props.headerHide);
  };

  openMapModal = async (event) => {
    this.disposeMap();
    const reportGeofenceId = this.state.reportDetails && this.state.reportDetails.geofenceId
      ? this.state.reportDetails.geofenceId
      : this.state.geofenceId;
    this.setState({
      selectedMapEvent: event,
      selectedGeofence: null,
      showMapModal: true,
    });

    try {
      const response = await axios.get(`${apiHost}/api/Report/PrivateGeofence/${reportGeofenceId}`, {
        headers: this.getAuthHeaders(),
      });
      this.setState({ selectedGeofence: response.data.geofence }, () => {
        setTimeout(this.renderMap, 150);
      });
    } catch (e) {
      console.warn("Report request failed");
      setTimeout(this.renderMap, 150);
    }
  };

  closeMapModal = () => {
    this.disposeMap();
    this.setState({
      showMapModal: false,
      selectedMapEvent: null,
      selectedGeofence: null,
    });
  };

  openPoiZonePreview = async (option, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.previewMenuHoldUntil = Date.now() + 1200;
    this.disposeMap();
    this.setState({
      geofenceMenuOpen: true,
      previewGeofence: null,
      showPreviewModal: true,
    });

    try {
      const response = await axios.get(`${apiHost}/api/Report/PrivateGeofence/${option.value}`, {
        headers: this.getAuthHeaders(),
      });
      this.setState({ previewGeofence: response.data.geofence }, () => {
        setTimeout(this.renderPreviewMap, 150);
      });
    } catch (e) {
      console.warn("Report request failed");
    }
  };

  closePreviewModal = () => {
    this.disposeMap();
    this.setState({
      showPreviewModal: false,
      previewGeofence: null,
      geofenceMenuOpen: true,
    });
  };

  disposeMap = () => {
    if (this.map) {
      this.map.dispose();
      this.map = null;
      this.mapUi = null;
    }
  };

  addMarker = (map, group, lat, lng, color, label, markerText) => {
    if (lat == null || lng == null || !window.H) {
      return;
    }

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40">
      <path fill="${color}" stroke="#ffffff" stroke-width="2.5" d="M15 1.5C7.8 1.5 2 7.3 2 14.5c0 9.9 13 23.5 13 23.5s13-13.6 13-23.5C28 7.3 22.2 1.5 15 1.5z"/>
      <circle cx="15" cy="14.5" r="8" fill="#ffffff"/>
      <text x="15" y="18" text-anchor="middle" font-family="Arial, sans-serif" font-size="10" font-weight="800" fill="${color}">${markerText}</text>
    </svg>`;
    const icon = new window.H.map.Icon(
      `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
      { size: { w: 30, h: 40 }, anchor: { x: 15, y: 40 } }
    );
    const marker = new window.H.map.Marker({ lat, lng }, { icon });
    marker.setData(label);
    marker.addEventListener("tap", (evt) => {
      if (!this.mapUi) {
        return;
      }

      const bubble = new window.H.ui.InfoBubble(evt.target.getGeometry(), {
        content: `<div class="geofence-map-bubble">${label}</div>`,
      });
      this.mapUi.getBubbles().forEach((item) => this.mapUi.removeBubble(item));
      this.mapUi.addBubble(bubble);
    });
    group.addObject(marker);
  };

  getMapFitBounds = (path, selectedMapEvent, selectedGeofence) => {
    if (!window.H) {
      return null;
    }

    const points = [];
    const addPoint = (lat, lng) => {
      const nextLat = Number(lat);
      const nextLng = Number(lng);
      if (Number.isFinite(nextLat) && Number.isFinite(nextLng)) {
        points.push({ lat: nextLat, lng: nextLng });
      }
    };

    (path || []).forEach((point) => addPoint(point.lat, point.lng));
    if (selectedMapEvent) {
      addPoint(selectedMapEvent.beforeEntryLat, selectedMapEvent.beforeEntryLng);
      addPoint(selectedMapEvent.entryLat, selectedMapEvent.entryLng);
      addPoint(selectedMapEvent.exitLat, selectedMapEvent.exitLng);
      addPoint(selectedMapEvent.afterExitLat, selectedMapEvent.afterExitLng);
    }

    if (selectedGeofence) {
      if (selectedGeofence.type === "circle" && selectedGeofence.lat != null && selectedGeofence.lng != null) {
        const centerLat = Number(selectedGeofence.lat);
        const centerLng = Number(selectedGeofence.lng);
        const radiusMeters = Number(selectedGeofence.radius) || 100;
        if (Number.isFinite(centerLat) && Number.isFinite(centerLng)) {
          const latDelta = radiusMeters / 111320;
          const lngDelta = radiusMeters / (111320 * Math.max(Math.cos(centerLat * Math.PI / 180), 0.0001));
          addPoint(centerLat, centerLng);
          addPoint(centerLat + latDelta, centerLng);
          addPoint(centerLat - latDelta, centerLng);
          addPoint(centerLat, centerLng + lngDelta);
          addPoint(centerLat, centerLng - lngDelta);
        }
      } else if ((selectedGeofence.type === "polygon" || selectedGeofence.type === "rectangle") && Array.isArray(selectedGeofence.polygon)) {
        selectedGeofence.polygon.forEach((point) => addPoint(point.lat, point.lng));
      }
    }

    if (!points.length) {
      return null;
    }

    const lats = points.map((point) => point.lat);
    const lngs = points.map((point) => point.lng);
    const top = Math.max(...lats);
    const bottom = Math.min(...lats);
    const left = Math.min(...lngs);
    const right = Math.max(...lngs);
    const latSpan = Math.max(top - bottom, 0.006);
    const lngSpan = Math.max(right - left, 0.006);
    const latPadding = Math.max(latSpan * 0.28, 0.0035);
    const lngPadding = Math.max(lngSpan * 0.28, 0.0035);

    return new window.H.geo.Rect(
      Math.min(90, top + latPadding),
      Math.max(-180, left - lngPadding),
      Math.max(-90, bottom - latPadding),
      Math.min(180, right + lngPadding)
    );
  };

  getPreviewFitBounds = (selectedGeofence) => {
    if (!window.H || !selectedGeofence) {
      return null;
    }

    const points = [];
    const addPoint = (lat, lng) => {
      const nextLat = Number(lat);
      const nextLng = Number(lng);
      if (Number.isFinite(nextLat) && Number.isFinite(nextLng)) {
        points.push({ lat: nextLat, lng: nextLng });
      }
    };

    if (selectedGeofence.type === "circle" && selectedGeofence.lat != null && selectedGeofence.lng != null) {
      const centerLat = Number(selectedGeofence.lat);
      const centerLng = Number(selectedGeofence.lng);
      const radiusMeters = Number(selectedGeofence.radius) || 100;
      if (Number.isFinite(centerLat) && Number.isFinite(centerLng)) {
        const latDelta = radiusMeters / 111320;
        const lngDelta = radiusMeters / (111320 * Math.max(Math.cos(centerLat * Math.PI / 180), 0.0001));
        addPoint(centerLat, centerLng);
        addPoint(centerLat + latDelta, centerLng);
        addPoint(centerLat - latDelta, centerLng);
        addPoint(centerLat, centerLng + lngDelta);
        addPoint(centerLat, centerLng - lngDelta);
      }
    } else if ((selectedGeofence.type === "polygon" || selectedGeofence.type === "rectangle") && Array.isArray(selectedGeofence.polygon)) {
      selectedGeofence.polygon.forEach((point) => addPoint(point.lat, point.lng));
    }

    if (!points.length) {
      return null;
    }

    const lats = points.map((point) => point.lat);
    const lngs = points.map((point) => point.lng);
    const top = Math.max(...lats);
    const bottom = Math.min(...lats);
    const left = Math.min(...lngs);
    const right = Math.max(...lngs);
    const latSpan = Math.max(top - bottom, 0.0007);
    const lngSpan = Math.max(right - left, 0.0007);
    const latPadding = Math.max(latSpan * 0.22, 0.00018);
    const lngPadding = Math.max(lngSpan * 0.22, 0.00018);

    return new window.H.geo.Rect(
      Math.min(90, top + latPadding),
      Math.max(-180, left - lngPadding),
      Math.max(-90, bottom - latPadding),
      Math.min(180, right + lngPadding)
    );
  };

  addGeofenceShape = (group, selectedGeofence) => {
    if (!selectedGeofence || !window.H) {
      return;
    }

    const color = selectedGeofence.color || "#1f6feb";
    if (selectedGeofence.type === "circle" && selectedGeofence.lat != null && selectedGeofence.lng != null) {
      const circle = new window.H.map.Circle(
        { lat: selectedGeofence.lat, lng: selectedGeofence.lng },
        selectedGeofence.radius || 100,
        { style: { strokeColor: color, lineWidth: 2, fillColor: "rgba(31, 111, 235, 0.18)" } }
      );
      group.addObject(circle);
      return;
    }

    if ((selectedGeofence.type === "polygon" || selectedGeofence.type === "rectangle") && Array.isArray(selectedGeofence.polygon)) {
      const strip = new window.H.geo.LineString();
      let polygonPointCount = 0;
      selectedGeofence.polygon.forEach((point) => {
        if (point && point.lat != null && point.lng != null) {
          strip.pushPoint({ lat: point.lat, lng: point.lng });
          polygonPointCount += 1;
        }
      });
      if (polygonPointCount >= 3) {
        const polygon = new window.H.map.Polygon(strip, {
          style: { strokeColor: color, lineWidth: 2, fillColor: "rgba(31, 111, 235, 0.18)" },
        });
        group.addObject(polygon);
      }
    }
  };

  renderMap = () => {
    const container = document.getElementById("geofenceEntryExitMap");
    const { selectedMapEvent, selectedGeofence } = this.state;
    if (!container || !selectedMapEvent || !window.H) {
      return;
    }

    this.disposeMap();
    container.innerHTML = "";
    const platform = new window.H.service.Platform({ apikey: here_api_key });
    const defaultLayers = platform.createDefaultLayers();
    const map = new window.H.Map(container, defaultLayers.vector.normal.map, {
      center: DEFAULT_MAP_CENTER,
      zoom: 5,
      pixelRatio: window.devicePixelRatio || 1,
    });
    new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));
    this.mapUi = window.H.ui.UI.createDefault(map, defaultLayers);
    this.map = map;

    const group = new window.H.map.Group();
    map.addObject(group);

    this.addGeofenceShape(group, selectedGeofence);

    const path = (selectedMapEvent.path || []).filter((point) => point && point.lat != null && point.lng != null);
    if (path.length >= 2) {
      const strip = new window.H.geo.LineString();
      path.forEach((point) => strip.pushPoint({ lat: point.lat, lng: point.lng }));
      const route = new window.H.map.Polyline(strip, {
        style: { strokeColor: "rgba(0, 128, 255, 0.85)", lineWidth: 4 },
      });
      group.addObject(route);
    }

    this.addMarker(map, group, selectedMapEvent.beforeEntryLat, selectedMapEvent.beforeEntryLng, "#22c55e", `Entry: ${selectedMapEvent.enteredAt}`, "E");
    this.addMarker(map, group, selectedMapEvent.afterExitLat, selectedMapEvent.afterExitLng, "#dc2626", `Exit: ${selectedMapEvent.exitedAt || "Still inside geofence"}`, "X");

    const bounds = this.getMapFitBounds(path, selectedMapEvent, selectedGeofence) || group.getBoundingBox();
    if (bounds) {
      const fitMap = () => {
        map.getViewPort().resize();
        map.getViewPort().setPadding(52, 72, 96, 72);
        map.getViewModel().setLookAtData({ bounds, tilt: 0 });
      };
      fitMap();
      setTimeout(fitMap, 250);
      setTimeout(fitMap, 700);
    }
  };

  renderPreviewMap = () => {
    const container = document.getElementById("geofencePreviewMap");
    const { previewGeofence } = this.state;
    if (!container || !previewGeofence || !window.H) {
      return;
    }

    this.disposeMap();
    container.innerHTML = "";
    const platform = new window.H.service.Platform({ apikey: here_api_key });
    const defaultLayers = platform.createDefaultLayers();
    const map = new window.H.Map(container, defaultLayers.vector.normal.map, {
      center: DEFAULT_MAP_CENTER,
      zoom: 5,
      pixelRatio: window.devicePixelRatio || 1,
    });
    new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));
    this.mapUi = window.H.ui.UI.createDefault(map, defaultLayers);
    this.map = map;

    const group = new window.H.map.Group();
    map.addObject(group);
    this.addGeofenceShape(group, previewGeofence);

    const bounds = this.getPreviewFitBounds(previewGeofence) || group.getBoundingBox();
    if (bounds) {
      const fitMap = () => {
        map.getViewPort().resize();
        map.getViewPort().setPadding(30, 42, 42, 42);
        map.getViewModel().setLookAtData({ bounds, tilt: 0 });
      };
      fitMap();
      setTimeout(fitMap, 250);
      setTimeout(fitMap, 700);
    }
  };

  renderResults = () => {
    const report = this.state.reportDetails;
    if (!report) {
      return null;
    }

    const events = report.events || [];
    return (
      <div className="geofence-report-results">
        <div className="geofence-report-summary">
          <div>
            <span>Events</span>
            <strong>{report.count || 0}</strong>
          </div>
          <div>
            <span>Total Time Inside</span>
            <strong>{report.totalDuration || "00:00:00"}</strong>
          </div>
          <div>
            <span>POI Zone</span>
            <div className="geofence-summary-zone-line">
              <strong>{report.geofenceName || "-"}</strong>
              {report.geofenceName && (
                <span className={report.geofencePrivate ? "geofence-zone-badge private" : "geofence-zone-badge public"}>
                  {report.geofencePrivate ? "Private" : "Public"}
                </span>
              )}
              {report.geofencePrivate && report.geofenceOwnerName && (
                <span className="geofence-zone-owner">{report.geofenceOwnerName}</span>
              )}
            </div>
          </div>
          <div>
            <span>Timezone</span>
            <strong>{report.timezone || "-"}</strong>
          </div>
        </div>
        <div className="geofence-report-table-wrap">
          <Table className="geofence-report-table" responsive>
            <thead>
              <tr>
                <th>Asset</th>
                <th>POI Zone</th>
                <th>Entered At</th>
                <th>Exited At</th>
                <th>Duration</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {events.length === 0 ? (
                <tr>
                  <td colSpan="6" className="geofence-report-empty">No entries found for this range.</td>
                </tr>
              ) : (
                events.map((event, index) => {
                  const isOvernight = event.enteredAt && event.exitedAt && event.enteredAt.slice(0, 10) !== event.exitedAt.slice(0, 10);
                  return (
                    <tr key={`${event.enteredAt}-${index}`} className={isOvernight ? "geofence-report-overnight" : ""}>
                      <td>{report.assetName || report.assetId}</td>
                      <td>{report.geofenceName}</td>
                      <td>{event.enteredAt}</td>
                      <td>{event.exitedAt || <span className="geofence-still-inside">Still Inside POI Zone</span>}</td>
                      <td>
                        {event.duration}
                        {isOvernight && <span className="geofence-overnight-badge">Overnight</span>}
                      </td>
                      <td className="geofence-report-actions">
                        <button type="button" onClick={() => this.openMapModal(event)}>View</button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
    );
  };

  render() {
    const selectStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: 44,
        backgroundColor: "#f8fafc",
        borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
        borderRadius: 8,
        boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
        "&:hover": {
          borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
        },
      }),
      indicatorSeparator: (base) => ({ ...base, backgroundColor: "#dbe4ef" }),
      option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
        color: state.isSelected ? "#fff" : "#26354f",
        fontSize: 13,
      }),
      placeholder: (base) => ({ ...base, color: "#7e8da1" }),
      singleValue: (base) => ({ ...base, color: "#17233c", fontWeight: 700 }),
      menu: (base) => ({ ...base, zIndex: 200, borderRadius: 8, overflow: "hidden" }),
    };

    const formatGeofenceOptionLabel = (option, meta) => {
      const isPrivate = this.isGeofencePrivate(option.data);
      const ownerName = this.getGeofenceOwnerName(option.data);
      return (
        <div className="geofence-zone-option">
          <span className="geofence-zone-option-name">{option.label}</span>
          <span className={isPrivate ? "geofence-zone-badge private" : "geofence-zone-badge public"}>
            {isPrivate ? "Private" : "Public"}
          </span>
          {isPrivate && ownerName && (
            <span className="geofence-zone-owner">{ownerName}</span>
          )}
          {meta.context === "menu" && option.value && (
            <button
              aria-label={`Preview ${option.label}`}
              className="geofence-zone-preview-button"
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
              onMouseDown={(event) => this.openPoiZonePreview(option, event)}
              title="Preview POI Zone"
              type="button"
            >
              <i className="fa fa-eye"></i>
            </button>
          )}
        </div>
      );
    };

    const groupOptions = this.state.groupDetails.map((group) => ({
      value: group.groupId,
      label: `${group.customername} - ${group.groupName}`,
      data: group,
    }));
    const selectedGroupOption = groupOptions.find((option) => option.value === this.state.groupId) || null;

    const assetOptions = this.state.assetList.map((asset) => ({
      value: asset.assetId,
      label: `${asset.name}${asset.customerName ? ` - ${asset.customerName}` : ""}`,
      data: asset,
    }));
    const selectedAssetOption = assetOptions.find((option) => option.value === this.state.assetId) || null;

    const geofenceOptions = this.state.geofences.map((geofence) => ({
      value: this.getGeofenceId(geofence),
      label: this.getGeofenceName(geofence),
      data: geofence,
    })).filter((option) => option.value !== "");
    const selectedGeofenceOption = geofenceOptions.find((option) => option.value === this.state.geofenceId) || null;

    const endDateLabel = moment(this.getEndDate()).format("dddd Do MMMM, YYYY");
    const canCreateReport = this.canCreateReport();
    const loadedReportParams = this.state.loadedReportParams;
    const hasPendingReportChanges = !!(
      loadedReportParams &&
      canCreateReport &&
      (
        (loadedReportParams.groupId || "") !== (this.state.groupId || "") ||
        (loadedReportParams.assetId || "") !== (this.state.assetId || "") ||
        (loadedReportParams.geofenceId || "") !== (this.state.geofenceId || "") ||
        loadedReportParams.reportDate !== this.state.reportDate ||
        loadedReportParams.endDate !== this.getEndDate() ||
        loadedReportParams.selectedRangeDays !== this.state.selectedRangeDays ||
        loadedReportParams.minDuration !== (parseInt(this.state.minDuration, 10) || 0)
      )
    );
    const calendarReport = this.state.calendarShow ? (
      <div className="ParentCalender" ref={this.setWrapperRef} style={{ position: "relative", zIndex: 100 }}>
        <div className="CalendarContainer" style={{ position: "absolute" }}>
          <Calendar
            maxDate={new Date()}
            onChange={this.onChangeDate}
            value={this.state.calendarStartDate}
          />
        </div>
      </div>
    ) : "";

    return (
      <Layout>
        <Helmet>
          <title>POI Zone Entry/Exit Report</title>
        </Helmet>
        <div className="contentBody">
          <div className={!this.props.headerHide
            ? "contentWrapper contentWrapperSmoothRelease report-modern-page geofence-report-page"
            : "contentWrapper contentWrapperSmooth report-modern-page geofence-report-page"}
          >
            <div className="reportHeaderTile">
              <div className="headingContainer report-modern-header">
                <div>
                  <h2 className="mainHeading">POI Zone Entry/Exit Report</h2>
                  <p>Review when a selected asset entered and exited one customer POI Zone.</p>
                </div>
                <i
                  className={this.props.headerHide ? "fa fa-window-restore" : "fa fa-window-maximize"}
                  onClick={this.handleWindow}
                />
              </div>
              <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                <div className="inputElement reportPickerField">
                  <label>Group</label>
                  <Select
                    value={selectedGroupOption}
                    options={groupOptions}
                    styles={selectStyles}
                    onChange={this.handleGroupSelection}
                    isClearable
                    isSearchable
                    placeholder="Search group"
                    noOptionsMessage={() => "No groups found"}
                  />
                  {this.state.isLoading && (
                    <GroupWarning
                      warningText={true}
                      warningTextHead="No Groups Found"
                      warningTextBody=" You do not have any group memberships. Please contact Support to ensure your account configured correctly."
                    />
                  )}
                </div>
                <div className="inputElement reportPickerField">
                  <label>Asset</label>
                  <Select
                    value={selectedAssetOption}
                    options={assetOptions}
                    styles={selectStyles}
                    onChange={this.handleAssetSelection}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.groupId && !this.state.assetId}
                    isLoading={this.state.assetLoader && this.state.groupId !== ""}
                    placeholder={this.state.groupId ? "Search asset" : "Select group first"}
                    noOptionsMessage={() => "No assets found"}
                  />
                </div>
                <div className="inputElement reportPickerField">
                  <label>POI Zone</label>
                  <Select
                    value={selectedGeofenceOption}
                    options={geofenceOptions}
                    styles={selectStyles}
                    formatOptionLabel={formatGeofenceOptionLabel}
                    onChange={this.handleGeofenceSelection}
                    menuIsOpen={this.state.geofenceMenuOpen}
                    onMenuOpen={() => this.setState({ geofenceMenuOpen: true })}
                    onMenuClose={this.handleGeofenceMenuClose}
                    isClearable
                    isSearchable
                    isDisabled={!this.state.assetId}
                    placeholder={this.state.assetId ? "Search POI Zones" : "Select asset first"}
                    noOptionsMessage={() => "No POI Zones found for this customer"}
                  />
                </div>
                <div className="inputElement reportPickerField geofence-min-duration-field">
                  <label>Min Duration (minutes)</label>
                  <input
                    min="0"
                    onChange={(event) => this.setState({ minDuration: event.target.value })}
                    type="number"
                    value={this.state.minDuration}
                  />
                </div>
                <div className="inputElement reportPickerField reportPickerDateField">
                  <label>Start Date</label>
                  <ReportButtonGroup
                    function={this.calendarFunction}
                    dropDown={calendarReport}
                    placeholder={this.state.dataPlaceholder}
                    icon="fa-calendar"
                  />
                </div>
                <div className="inputElement reportPickerField geofence-range-field">
                  <label>Range</label>
                  <div className="geofence-range-buttons">
                    {RANGE_OPTIONS.map((option) => (
                      <button
                        className={this.state.selectedRangeDays === option.days ? "active" : ""}
                        key={option.days}
                        onClick={() => this.handleRangeChange(option.days)}
                        type="button"
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                  <p>Ends {endDateLabel}</p>
                </div>
                <div className="inputElement reportPickerActions">
                  <Button
                    className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                    variant="primary"
                    onClick={this.handleCreateReport}
                    size="sm"
                    disabled={!canCreateReport}
                  >
                    <i className="fa fa-map-marker"></i>
                    Create Report
                  </Button>
                </div>
              </div>
            </div>
            <TimeZoneConvert />
            <div className="reportBody">
              {this.state.reportLoader ? (
                <div className="loaderLine">
                  <br />
                  <GridLoader size={7} color="#222222" loading={this.state.reportLoader} />
                  <h1> &nbsp;Generating Report</h1>
                  <br />
                </div>
              ) : this.state.errorLoader ? (
                <AssetInforWarning warningText={true} warningTextMsg={this.state.errorMessage || "Something went wrong while generating this report."} />
              ) : this.state.reportGenerated ? (
                this.renderResults()
              ) : (
                <AssetInforWarning warningText={true} warningTextMsg="Please select a group, asset and POI Zone to generate this report." />
              )}
            </div>
          </div>
        </div>
        <Modal className="geofence-map-modal" show={this.state.showMapModal} onHide={this.closeMapModal} size="xl" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.reportDetails ? this.state.reportDetails.assetName : "Asset"}
              <span> @ </span>
              {this.state.reportDetails ? this.state.reportDetails.geofenceName : "POI Zone"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="geofenceEntryExitMap" className="geofence-entry-exit-map"></div>
            <div className="geofence-map-legend">
              <span><i className="entry"></i>Entry: {this.state.selectedMapEvent ? this.state.selectedMapEvent.enteredAt : "-"}</span>
              <span><i className="exit"></i>Exit: {this.state.selectedMapEvent ? this.state.selectedMapEvent.exitedAt || "Still inside geofence" : "-"}</span>
            </div>
          </Modal.Body>
        </Modal>
        <Modal className="geofence-map-modal geofence-preview-modal" show={this.state.showPreviewModal} onHide={this.closePreviewModal} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.previewGeofence ? this.state.previewGeofence.name : "POI Zone Preview"}
              {this.state.previewGeofence && (
                <span className={this.state.previewGeofence.private ? "geofence-zone-badge private inline" : "geofence-zone-badge public inline"}>
                  {this.state.previewGeofence.private ? "Private" : "Public"}
                </span>
              )}
              {this.state.previewGeofence && this.state.previewGeofence.private && this.state.previewGeofence.ownerName && (
                <span className="geofence-zone-owner inline">{this.state.previewGeofence.ownerName}</span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div id="geofencePreviewMap" className="geofence-preview-map"></div>
          </Modal.Body>
        </Modal>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
});

const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeofenceEntryExit);
